module.exports = __webpack_public_path__ + "img/Plus_emp.a3c7cdf5.svg";